module.exports = __webpack_public_path__ + "static/media/za.6cca9678.png";